import React from 'react';
import * as Cesium from 'cesium';
import { Entity, ModelGraphics, PathGraphics } from 'resium';
import { Types } from '@wheeebo/polaris-api';
const DRONE_MODEL_URI = '/quadrocopter.glb';
const HOVERBIKE_MODEL_URI = '/hoverbike.glb';
const DRONE_HEADING_ADJUSTMENT = Cesium.Math.PI_OVER_TWO;
const HOVERBIKE_HEADING_ADJUSTMENT = -Cesium.Math.PI_OVER_TWO;
function createProperty(path, latency, vehicleType) {
    const position = new Cesium.SampledPositionProperty();
    const orientation = new Cesium.TimeIntervalCollectionProperty();
    path?.forEach((e, i) => {
        const startElement = e;
        const isLast = i === (path.length || 0) - 1;
        const stopElement = isLast ? e : path[i + 1];
        const startPosition = Cesium.Cartesian3.fromDegrees(startElement.lng, startElement.lat, startElement.alt);
        // Add some delay for the last element, which makes the drone movement look smoother.
        const startTime = Cesium.JulianDate.fromDate(new Date(startElement.time + (isLast ? 1.2 : 1) * latency));
        const stopTime = Cesium.JulianDate.fromDate(new Date(stopElement.time + (isLast ? 1.2 : 1) * latency));
        const headingAdjustment = vehicleType === Types.VehicleTypeDrone ? DRONE_HEADING_ADJUSTMENT : HOVERBIKE_HEADING_ADJUSTMENT;
        const heading = Math.atan2(stopElement.lng - startElement.lng, stopElement.lat - startElement.lat) + headingAdjustment;
        const hpr = new Cesium.HeadingPitchRoll(heading, 0, 0);
        const data = Cesium.Transforms.headingPitchRollQuaternion(startPosition, hpr);
        orientation.intervals.addInterval(new Cesium.TimeInterval({ start: startTime, stop: stopTime, data }));
        position.addSample(startTime, startPosition);
    });
    return { position, orientation };
}
function FootprintEntity({ footprint, latency, tracked, start, stop, onClick }) {
    const color = tracked ? Cesium.Color.TURQUOISE : Cesium.Color.AQUAMARINE;
    const property = createProperty(footprint.path, latency, footprint.vehicle?.vehicleType);
    return (React.createElement(Entity, { id: footprint.vehicle.id, tracked: tracked, position: property.position, onClick: onClick, orientation: property.orientation, availability: new Cesium.TimeIntervalCollection([new Cesium.TimeInterval({ start, stop })]) },
        footprint.vehicle?.vehicleType === Types.VehicleTypeDrone ? (React.createElement(ModelGraphics, { uri: DRONE_MODEL_URI, runAnimations: true, scale: 1 / 250, maximumScale: 1.25, minimumPixelSize: 32 })) : (React.createElement(ModelGraphics, { uri: HOVERBIKE_MODEL_URI, runAnimations: true, scale: 2, maximumScale: 125, minimumPixelSize: 32 })),
        React.createElement(PathGraphics, { resolution: 1, width: 10, material: new Cesium.PolylineGlowMaterialProperty({ glowPower: 0.1, color, taperPower: 0.3 }) })));
}
export default React.memo(FootprintEntity);
